import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { Button } from './ui/button';
import { CheckCircle, AlertCircle, ArrowLeft } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UnsubscribePage() {
  const { token } = useParams();
  const [state, setState] = useState({ status: 'loading', message: '', email: '' });

  useEffect(() => {
    axios.post(`${API}/newsletter/unsubscribe/${token}`)
      .then(({ data }) => setState({ status: 'ok', message: data.message, email: data.data.email }))
      .catch((err) => setState({
        status: 'error',
        message: typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'No se pudo procesar la baja.',
        email: '',
      }));
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-10 text-center" data-testid="unsubscribe-card">
        <p className="text-3xl font-bold leading-none mb-8">
          <span className="text-blue-600">IWANNA</span>{' '}
          <span className="text-red-500 text-xl font-medium">insurance</span>
        </p>

        {state.status === 'loading' && (
          <div className="py-6" data-testid="unsubscribe-loading">
            <div className="animate-spin rounded-full h-10 w-10 border-2 border-blue-600 border-t-transparent mx-auto mb-4"></div>
            <p className="text-slate-600">Procesando tu solicitud...</p>
          </div>
        )}

        {state.status === 'ok' && (
          <div data-testid="unsubscribe-success">
            <CheckCircle className="h-14 w-14 text-emerald-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-slate-800 mb-2">Baja confirmada</h1>
            <p className="text-slate-600 mb-1">{state.message}</p>
            {state.email && <p className="text-sm text-slate-500" data-testid="unsubscribe-email">{state.email}</p>}
          </div>
        )}

        {state.status === 'error' && (
          <div data-testid="unsubscribe-error">
            <AlertCircle className="h-14 w-14 text-red-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-slate-800 mb-2">Enlace no válido</h1>
            <p className="text-slate-600">{state.message}</p>
          </div>
        )}

        <Link to="/" data-testid="unsubscribe-back-home">
          <Button className="mt-8 rounded-full bg-blue-600 hover:bg-blue-700 text-white px-6">
            <ArrowLeft className="h-4 w-4 mr-2" /> Volver a la página
          </Button>
        </Link>
      </div>
    </div>
  );
}
